
import moment from 'moment-timezone';

import { DateTime } from 'luxon';
import axios from 'axios';

function formatDate(strDate) {
    if (!strDate)
        return '';
    else
        return String((new Date(strDate).getMonth() + 1)).padStart(2, '0') + '/' + String(new Date(strDate).getDate()).padStart(2, '0') + '/' + new Date(strDate).getFullYear();
}

function formatDateBar(strDate) {
    if (!strDate)
        return '';
    else
        return String((new Date(strDate).getMonth() + 1)).padStart(2, '0') + '-' + String(new Date(strDate).getDate()).padStart(2, '0') + '-' + new Date(strDate).getFullYear();
}

function formatDateTimeEst(strDate) {
    if (!strDate) return '';

    return moment(strDate).format('MM/DD/YYYY h:mm A');
}

// function formatDateTimeEst(strDate) {
//     if (!strDate) return '';

//     // Parse the input as UTC, then convert to America/New_York
//     const easternTime = moment.utc(strDate).tz('America/New_York');
//     return easternTime.format('MM/DD/YYYY h:mm A');
// }

function formatDateByFormate(strDate, formate) {
    if (!strDate || strDate == '')
        return '';
    else
        return moment(strDate).format(formate);
}
function formatDateTime(strDate) {
    if (!strDate)
        return '';
    else {
        var time = moment(strDate).format('h:mm A');
        return String((new Date(strDate).getMonth() + 1)).padStart(2, '0') + '/' + String(new Date(strDate).getDate()).padStart(2, '0') + '/' + new Date(strDate).getFullYear() + ' ' + (time ? time : '');
    }
}

function formatDateTime2(strDate) {
    if (!strDate)
        return '';
    else {
        var time = moment(strDate).format('h:mm A');
        return String((new Date(strDate).getMonth() + 1)).padStart(2, '0') + '/' + String(new Date(strDate).getDate()).padStart(2, '0') + '/' + new Date(strDate).getFullYear() + (time ? ' | ' + time : '');
    }
}

function formatDateTimewithTime(strDate) {
    if (!strDate) return '';

    return moment(strDate).format('dddd, MMMM DD, YYYY h:mm A');
}


function formatTime(strDate) {
    if (!strDate)
        return '';
    else
        return moment(strDate).format('h:mm A');
}
function formatTimeFull(strDate) {
    if (!strDate)
        return '';
    else
        return moment(strDate).format('h:mm');
}

const maskCreditCardNumberFourDigits = (ccNumber) => {
    if (ccNumber && ccNumber.length >= 4) {
        return "**** **** **** " + ccNumber.slice(-4);
    }
    return ccNumber; // Return the original if it's not long enough
};

const maskAccountNumberFourDigits = (ccNumber) => {
    if (ccNumber && ccNumber.length >= 4) {
        return "****" + ccNumber.slice(-4);
    }
    return ccNumber; // Return the original if it's not long enough
};


function formatCurrency(x) {
    if (x !== undefined && x !== null) {
        const isNegative = x < 0;
        const absoluteValue = Math.abs(Number.parseFloat(x));
        const formattedValue = '$' + absoluteValue.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return isNegative ? `-${formattedValue}` : formattedValue;
    } else {
        return '$0.00';
    }
}

//function formatCurrency(x) {
//    if (x)
//        return '$' + Number.parseFloat(x).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
//    else return '$0.00';
//}
function formatNumberComma(number) {
    if (number) {
        number = number.toString().replace(',', '');
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return '0';
    }
}
function formatAmountComma(x) {
    if (x)
        return '$' + Number.parseFloat(x).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    else
        return '-';
}
function formatNumber(number) {
    var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

    // what tier? (determines SI symbol)
    var tier = Math.log10(Math.abs(number)) / 3 | 0;

    // if zero, we don't need a suffix
    if (tier == 0) return number;

    // get suffix and determine scale
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);

    // scale the number
    var scaled = number / scale;

    // format number and add suffix
    return scaled.toFixed(1) + suffix;


}
function formatNumber2(number) {
    if (!number) {
        return '';
    }
    number = parseFloat(number);
    const roundedNum = Math.round(number * 100) / 100;
    if (Number.isInteger(roundedNum)) {
        return roundedNum.toString(); // Return as a string without decimal point for whole numbers
    } else {
        return roundedNum.toFixed(2); // Return with 2 decimal points for numbers with decimals
    }
}
function validateEmail(email) {
    let re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
    if (re.test(String(email).toLowerCase())) {
        re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return re.test(String(email).toLowerCase())
    } else { return false; }
}
function getAgeByDOBInYears(birthDate, seperator) {
    var result = '';
    if (birthDate.trim() != '' && birthDate != undefined) {

        var mdate = birthDate;
        var yearThen = parseInt(mdate.substring(0, 4), 10);
        var monthThen = parseInt(mdate.substring(5, 7), 10);
        var dayThen = parseInt(mdate.substring(8, 10), 10);

        var today = new Date();
        var birthday = new Date(yearThen, monthThen - 1, dayThen);
        var differenceInMilisecond = today.valueOf() - birthday.valueOf();

        var year_age = Math.floor(differenceInMilisecond / 31536000000);

        if (isNaN(year_age))
            result = '';
        else if (year_age > 0)
            result = seperator + year_age + " yrs";

    }
    else {
        result = ''
    }
    return result;
}

function toDayDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;
    return today;
}

function getAgeByDOB(birthDate) {
    var result = '';
    if (birthDate.trim() != '' && birthDate != undefined) {

        var mdate = birthDate;
        var yearThen = parseInt(mdate.substring(0, 4), 10);
        var monthThen = parseInt(mdate.substring(5, 7), 10);
        var dayThen = parseInt(mdate.substring(8, 10), 10);

        var today = new Date();
        var birthday = new Date(yearThen, monthThen - 1, dayThen);
        var differenceInMilisecond = today.valueOf() - birthday.valueOf();

        var year_age = Math.floor(differenceInMilisecond / 31536000000);
        var day_age = Math.floor((differenceInMilisecond % 31536000000) / 86400000);
        var month_age = Math.floor(day_age / 30);
        day_age = day_age % 30;


        if (isNaN(year_age) || isNaN(month_age) || isNaN(day_age))
            result = '';
        else if (year_age > 0)
            result = year_age + ' years, ' + month_age + (month_age > 1 ? ' months, ' : ' month, ') + day_age + (day_age > 1 ? ' days' : ' day');
        else if (year_age === 0 && month_age > 0)
            result = month_age + (month_age > 1 ? ' months, ' : ' month, ') + day_age + (day_age > 1 ? ' days' : ' day');
        else if (year_age > 0 && month_age === 0)
            result = year_age + (year_age > 1 ? ' years, ' : ' year,') + day_age + (day_age > 1 ? ' days' : ' day');
        else if (day_age === 0)
            result = '';
        else
            result = day_age + (day_age > 1 ? ' days' : ' day');
    }
    return result;
}


function getFormatedDate(_date, _formate) {
    if (!_date) {
        return '';
    }
    return moment(_date).format(_formate)
}

const formatDateTime3 = (dateTimeStr, timeStr) => {
    // Split the dateTimeStr to get the date part
    const [dateStr] = dateTimeStr.split(' ');

    // Create a new Date object from the date part
    const date = new Date(dateStr);

    // Split the time string into hours, minutes, and seconds
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);

    // Set the hours, minutes, and seconds on the Date object
    date.setHours(hours, minutes, seconds);

    // Format the date and time strings
    const formattedDate = date.toLocaleDateString('en-US');
    const formattedTime = date.toLocaleTimeString('en-US', { hour12: false });

    // Combine the formatted date and time
    return `${formattedDate} ${formattedTime}`;
};

function getFormatedTemplateDetails(txtToAdd, patientDetails) {
    var array = [];
    if (patientDetails.address != null) {
        array.push(patientDetails.address);
    }
    if (patientDetails.city != null) {
        array.push(patientDetails.city);
    }
    if (patientDetails.state != null) {
        array.push(patientDetails.state);
    }
    if (patientDetails.countyCode != null) {
        array.push(patientDetails.countyCode);
    }
    if (patientDetails.country != null) {
        array.push(patientDetails.country);
    }
    var formatedValue = array.join(", ");
    return txtToAdd.
        replaceAll('[Patient Name]', patientDetails.name != null ? patientDetails.name : '').
        replaceAll('[Age]', patientDetails.birthDate != null ? getAgeByDOB(patientDetails.birthDate) : '').
        replaceAll('[Date of Birth]', patientDetails.birthDate != null ? getFormatedDate(patientDetails.birthDate, 'MM/DD/YYYY') : '').
        replaceAll('[Date of birth]', patientDetails.birthDate != null ? getFormatedDate(patientDetails.birthDate, 'MM/DD/YYYY') : '').
        replaceAll('[Phone]', patientDetails.cellPhone != null ? patientDetails.cellPhone : '').
        replaceAll('[Address]', formatedValue != null ? formatedValue : '').replaceAll('<p>', '').replaceAll('</p>', '').trim();
}

function getFormatedTemplateDetailChiefComplaint(txtToAdd, patientDetails) {
    var array = [];
    if (patientDetails.address != null) {
        array.push(patientDetails.address);
    }
    if (patientDetails.city != null) {
        array.push(patientDetails.city);
    }
    if (patientDetails.state != null) {
        array.push(patientDetails.state);
    }
    if (patientDetails.countyCode != null) {
        array.push(patientDetails.countyCode);
    }
    if (patientDetails.country != null) {
        array.push(patientDetails.country);
    }
    var formatedValue = array.join(", ");
    return txtToAdd.
        replaceAll('[Patient Name]', patientDetails.name != null ? patientDetails.name : '').
        replaceAll('[Age]', patientDetails.birthDate != null ? getAgeByDOB(patientDetails.birthDate) : '').
        replaceAll('[Date of Birth]', patientDetails.birthDate != null ? getFormatedDate(patientDetails.birthDate, 'MM/DD/YYYY') : '').
        replaceAll('[Date of birth]', patientDetails.birthDate != null ? getFormatedDate(patientDetails.birthDate, 'MM/DD/YYYY') : '').
        replaceAll('[Phone]', patientDetails.cellPhone != null ? patientDetails.cellPhone : '').
        replaceAll('[Address]', formatedValue != null ? formatedValue : '').trim();
}


function numberFormat(x) {
    return Number.parseFloat(x).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}


const validDate = (date) => {
    let minimumDate = new Date('1753-01-01');
    let maximumDate = new Date('9999-12-31');
    let actualDate = new Date(date);
    if (actualDate.valueOf() < minimumDate.valueOf() || actualDate.valueOf() > maximumDate.valueOf()) {
        return true
    } else {
        return false
    }
}
const todayDate = () => {
    return new Date().getFullYear() + '-' + String((new Date().getMonth() + 1)).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0');
}
const formateMdnNumber = (mdnNumber) => {
    if (!mdnNumber || mdnNumber == '') {
        return ''
    }
    var cleaned = ('' + mdnNumber).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    var number = mdnNumber;
    if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return number;
}

const formatPhoneNumber = (mdnNumber) => {
    if (!mdnNumber) {
        return '';
    }
    const cleaned = ('' + mdnNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
        const intlCode = '';
        return [intlCode, match[1] ? '(' + match[1] : '', match[2] ? ') ' + match[2] : '', match[3] ? '-' + match[3] : ''].join('');
    }
    return mdnNumber;
}


function formatSizeUnits(bytes, seperator = " ") {
    const sizes = ['KB', 'MB', 'GB', 'TB']
    if (bytes == 0 || bytes == undefined)
        return '---'
    else if (bytes < 1024) {
        return Math.round(bytes).toFixed(2) + ' Bytes';
    } else {
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
        if (i === 0) return `${bytes}${seperator}${sizes[i]}`
        return `${(bytes / (1024 ** i)).toFixed(2)}${seperator}${sizes[i]}`
    }


}

function getSizeUnit(bytes, seperator = " ") {
    const sizes = ['Bytes', 'KBs', 'MBs', 'GBs', 'TBs']
    if (bytes == 0 || bytes == undefined) return `${sizes[0]}`
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    return `${sizes[i]}`

}

function getDigitsToLocalString(data) {
    if (data == 0 || data == undefined || data == '') return '0'
    return data.toLocaleString();

}

function convertMinToHours(minutes) {
    if (minutes == 0 || minutes == undefined || minutes == '') return '0 mins'
    var hours = Math.floor(minutes / 60);
    var minutes = Math.floor(minutes % 60)
    return hours > 0 ? hours + " Hrs " + minutes + " mins " : minutes + " mins"
}
function validatePhoneNumber(input_str) {
    var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return re.test(input_str);
}
const handleNumberKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /\d/.test(keyValue);
    const isSpecialChar = /[^a-zA-Z0-9]/.test(keyValue);
    if (!isNumber || isSpecialChar) {
        event.preventDefault();
    }
}

const handleNumberKeyPressDecimal = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumberOrDecimal = /^\d*\.?\d*$/.test(keyValue);
    const isSpecialChar = /[^a-zA-Z0-9.]/.test(keyValue);
    if (!isNumberOrDecimal || isSpecialChar) {
        event.preventDefault();
    }
}


function allowedAttachments() {

    let arrMessages = [];

    arrMessages["jpg"] = "jpg";
    arrMessages["bmp"] = "bmp";
    arrMessages["png"] = "png";
    arrMessages["PNG"] = "PNG";
    arrMessages["tif"] = "tif";
    arrMessages["jpeg"] = "jpeg";
    arrMessages["JPEG"] = "JPEG";
    arrMessages["xls"] = "xls";
    arrMessages["xlsx"] = "xlsx";
    arrMessages["txt"] = "txt";
    arrMessages["pdf"] = "pdf";
    arrMessages["xps"] = "xps";
    arrMessages["gif"] = "gif";
    arrMessages["doc"] = "doc";
    arrMessages["ppa"] = "ppa";
    arrMessages["ppt"] = "ppt";
    arrMessages["rtf"] = "rtf";

    return arrMessages;

}

function allowedAttachmentsImages() {

    let arrMessages = [];

    arrMessages["jpg"] = "jpg";
    arrMessages["png"] = "png";
    arrMessages["PNG"] = "PNG";
    arrMessages["jpeg"] = "jpeg";
    arrMessages["JPEG"] = "JPEG";
    return arrMessages;

}

const handleNumberChange = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /\d/.test(keyValue);
    if (!isNumber) {
        event.preventDefault();
    }
}

const handleNumberWithDecimal = (event) => {

    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /\d/.test(keyValue);
    const isDecimalPoint = keyValue === '.';
    const isSpecialChar = /[^a-zA-Z0-9.]/.test(keyValue);

    const inputField = event.target;
    const existingValue = inputField.value;
    const cursorPosition = inputField.selectionStart;
    const newValue = existingValue.slice(0, cursorPosition) + keyValue + existingValue.slice(cursorPosition);

    const decimalCount = (newValue.match(/\./g) || []).length;
    const afterDecimalCount = decimalCount > 0 ? newValue.split('.')[1].length : 0;

    if ((!isNumber && !isDecimalPoint) || isSpecialChar || decimalCount > 1 || afterDecimalCount > 2) {
        event.preventDefault();
    }
}

const handleNumberWithDecimalMaxLenght = (event, maxLength) => {

    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /\d/.test(keyValue);
    const isDecimalPoint = keyValue === '.';
    const isSpecialChar = /[^a-zA-Z0-9.]/.test(keyValue);

    const inputField = event.target;
    const existingValue = inputField.value;
    const cursorPosition = inputField.selectionStart;
    const newValue = existingValue.slice(0, cursorPosition) + keyValue + existingValue.slice(cursorPosition);

    const decimalCount = (newValue.match(/\./g) || []).length;
    const afterDecimalCount = decimalCount > 0 ? newValue.split('.')[1].length : 0;
    const beforeDecimalCount = newValue.split('.')[0].length > maxLength;

    if ((!isNumber && !isDecimalPoint) || isSpecialChar || decimalCount > 1 || afterDecimalCount > 2 || beforeDecimalCount) {
        event.preventDefault();
    }
}

const handleNegativeNumberWithDecimal = (event) => {

    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isNumber = /^-?\d*$/.test(keyValue);
    const isDecimalPoint = keyValue === '.';
    const isNegativePoint = keyValue === '-';
    const isSpecialChar = /[^a-zA-Z0-9.]/.test(keyValue);

    const inputField = event.target;
    const existingValue = inputField.value;
    const cursorPosition = inputField.selectionStart;
    const newValue = existingValue.slice(0, cursorPosition) + keyValue + existingValue.slice(cursorPosition);

    const decimalCount = (newValue.match(/\./g) || []).length;
    const negativeCount = (newValue.match(/\-/g) || []).length;
    const indexOfNegative = newValue.indexOf('-');

    if ((!isNumber && !isDecimalPoint) || decimalCount > 1 || negativeCount > 1 || indexOfNegative > 0) {
        event.preventDefault();
    }
}


function numberDisplay(number, _minimumFractionDigits, _maximumFractionDigits, _return) {
    if (!number) {
        return _return;
    }
    const formattedNumber = number.toLocaleString("en-US", {
        minimumFractionDigits: _minimumFractionDigits,
        maximumFractionDigits: _maximumFractionDigits,
    });

    return formattedNumber;
}

const orderTrackStatus = (type) => {
    var status = '';
    if (type == 'D') { status = 'Delivered' }
    else if (type == 'I') { status = 'In Transit' }
    else if (type == 'M') { status = 'Billing Information Received' }
    else if (type == 'MV') { status = 'Billing Information Voided' }
    else if (type == 'P') { status = 'Pickup' }
    else if (type == 'X') { status = 'Exception' }
    else if (type == 'RS') { status = 'Returned to Shipper' }
    else if (type == 'DO') { status = 'Delivered Origin CFS(Freight Only)' }
    else if (type == 'DD') { status = 'Delivered Destination CFS(Freight Only)' }
    else if (type == 'W') { status = 'Warehousing(Freight Only)' }
    else if (type == 'NA') { status = 'Not Available' }
    else if (type == 'O') { status = 'Out for Delivery' }
    else if (type == 'Deleted') { status = 'Deleted' }
    return status;
};

const shipmentStatus = (type) => {
    var status = type;
    if (type == 'I' || type == 'P' || type == 'DO' || type == 'DD' || type == 'O') {
        status = 'I'
    }
    if (type == 'M' || type == 'FR') {
        status = 'M'
    }
    return status;
};

// Get the current datetime
const currentDatetime = new Date();
// Calculate the start and end of the previous week
const startOfPreviousWeek = new Date(
    currentDatetime.getFullYear(),
    currentDatetime.getMonth(),
    currentDatetime.getDate() - 7
);
const endOfPreviousWeek = new Date(
    currentDatetime.getFullYear(),
    currentDatetime.getMonth(),
    currentDatetime.getDate() - 1
);

const communicationFormatedDate = (_date) => {
    var _formatedDate = '';
    if (getFormatedDate(_date, "DD-MM-yyyy") == getFormatedDate(new Date(), "DD-MM-yyyy")) {
        _formatedDate = formatTime(_date)
    } else if (new Date(_date) >= startOfPreviousWeek && new Date(_date) <= endOfPreviousWeek) {
        _formatedDate = getFormatedDate(_date, "ddd");
    }
    else {
        _formatedDate = getFormatedDate(_date, "DD-MMM-yyyy");
    }
    return _formatedDate;
};

const loadNameInitials = (name) => {
    const initials = name
        .split(' ')
        .map(word => word.charAt(0))
        .join('');
    return initials;
}

const validateDateOfBirth = (dateOfBirth) => {
    const inputDate = new Date(dateOfBirth);
    const currentDate = new Date();
    if (isNaN(inputDate.getTime())) {
        // Invalid date format
        return false;
    } else if (inputDate > currentDate) {
        // Date of birth is in the future
        return false;
    } else {
        return true;
    }
};

function wirelessStatus(_value) {
    if (_value == '1')
        return 'Inactive';
    else if (_value == '2')
        return 'Active';
    else if (_value == '3')
        return 'Suspended';
    else if (_value == '4')
        return 'Disconnected';
    else if (_value == '6')
        return 'Hotlined';
    else if (_value == '7')
        return 'Rejected';
    else if (_value == '8')
        return 'Port In Cancelled';
}

const isDigitsOnly = (keyValue) => {
    const isNumber = /^\d+$/.test(keyValue);  // Updated regex to check if it's a number
    const isSpecialChar = /[^0-9]/.test(keyValue);
    if (!isNumber || isSpecialChar) {
        return false;
    } else {
        return true;
    }
}

const maskCreditCardNumber = (ccNumber) => {
    var result = ccNumber;
    if (ccNumber && ccNumber.length > 15) {
        result = "**** **** **** " + ccNumber.substring(ccNumber.length - 4, ccNumber.length);
    }
    else if (ccNumber && ccNumber.length == 4) {
        result = "**** **** **** " + ccNumber;
    }
    return result;
}

const maskCreditCardNumberPripaid = (ccNumber) => {
    let cleanNumber = ccNumber.replace(/\D/g, '');
    if (cleanNumber.length > 15) {
        return "**** **** **** " + cleanNumber.substring(cleanNumber.length - 4);
    }
    return ccNumber;
};

const maskCardNumber = (value) => {
    if (!value) {
        return ''; // Return an empty string or handle as per your requirement
    }
    value = value.toString().replace(/\D/g, ''); // Convert to string to handle potential non-string inputs
    if (value.length > 16) {
        value = value.slice(0, 16);
    }
    return value.match(/.{1,4}/g)?.join('-') || '';
};

function getLocalDateFromUTC(utcDateTimeString) {
    if (utcDateTimeString == null || utcDateTimeString == '') {
        return '';
    }
    const utcDateTime = DateTime.fromISO(utcDateTimeString, { zone: 'utc' });
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDateTime = utcDateTime.setZone(userTimeZone);
    return new Date(localDateTime);
}

function invoiceDocsAttachments() {

    let arrMessages = [];

    arrMessages["jpg"] = "jpg";
    arrMessages["JPG"] = "JPG";
    arrMessages["bmp"] = "bmp";
    arrMessages["png"] = "png";
    arrMessages["PNG"] = "PNG";
    arrMessages["jpeg"] = "jpeg";
    arrMessages["JPEG"] = "JPEG";
    // arrMessages["xls"] = "xls";
    // arrMessages["xlsx"] = "xlsx";
    arrMessages["pdf"] = "pdf";
    arrMessages["doc"] = "doc";
    arrMessages["docx"] = "docx";
    arrMessages["zip"] = "zip";

    return arrMessages;

}





function generateRandomNumber() {
    return Math.random().toString(36).substring(2, 9) + Date.now().toString(36);
}
function formatCreditCardNumber(cardNumber) {
    if (!cardNumber)
        return '';
    else {

        return '**** **** **** ' + cardNumber.slice(-4);
    }
}

const handlePaste = (event) => {
    event.preventDefault(); // Prevent pasting
}
const getUserStatusText = (value) => {
    var statusText = '';
    switch (value) {
        case 1:
            statusText = 'Active';
            break;
        case 2:
            statusText = 'Disabled';
            break;
        case 3:
            statusText = 'Locked';
            break;
        default:
    }
    return statusText;
}

const calculateDaysDifference = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return '0';
    }
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the difference in milliseconds and convert to days
    const difference = (end - start) / (1000 * 3600 * 24);

    return difference < 0 ? 0 : difference;
}
function IsVerizonSIM(input) {
    return /0000/.test(input);
}
function CalculatePercentage(part, whole) {
    if (whole === 0) return 0;
    const percentage = ((whole - part) / whole) * 100;
    return parseFloat(percentage.toFixed(2)); // Ensure two decimal places
}

function calculatePartFromPercentage(percentage, whole) {
    const part = whole * (1 - percentage / 100);
    return parseFloat(part.toFixed(2)); // Ensure two decimal places
}

// async function getConfiguration(configCode) {
//     try {

//         const response = await axios.get('/config.json');
//         return response.data[configCode]; // Access the data directly
//     } catch (error) {
//         console.error("Failed to load configuration");
//         return null; // or an appropriate fallback value
//     }
// }


async function getConfiguration(configCode) {
    try {
        // Dynamically construct the base path
        const basePath = window.location.origin + window.location.pathname.replace(/\/[^/]*$/, '');
        const configUrl = `${basePath}/config.json`;

        const response = await axios.get(configUrl);
        return response.data[configCode]; // Access the data directly
    } catch (error) {
        console.error("Failed to load configuration", error);
        return null; // or an appropriate fallback value
    }
}
let configData = null; // Store config globally

// Load configuration once at startup
async function getConfigurationSync() {
    try {
        const basePath = window.location.origin + window.location.pathname.replace(/\/[^/]*$/, '');
        const configUrl = `${basePath}/config.json`;

        const response = await axios.get(configUrl);
        configData = response.data;
        console.log("Configuration loaded successfully:", configData);
    } catch (error) {
        console.error("Failed to load configuration", error);
    }
}


function formatDecimalNumber(number) {
    if (number === null || number === undefined || isNaN(number)) {
        return ''; // Return an empty string for null, undefined, or non-numeric values
    }

    number = parseFloat(number);

    // Round the number to two decimal places
    const roundedNum = Math.round(number * 100) / 100;

    // Check if the rounded number is an integer
    if (Number.isInteger(roundedNum)) {
        return roundedNum.toString(); // Return as a string without decimal point for whole numbers
    } else {
        return roundedNum.toFixed(2); // Return with 2 decimal points for numbers with decimals
    }
}
function getRemainingDays(dob) {
    if (!dob) return null;

    const today = new Date();
    const birthDate = new Date(dob);

    let nextBirthday = new Date(
        today.getFullYear(),
        birthDate.getMonth(),
        birthDate.getDate()
    );

    // Check if today is birthday
    if (
        today.getMonth() === birthDate.getMonth() &&
        today.getDate() === birthDate.getDate()
    ) {
        return 0;
    }

    // If birthday already passed this year → move to next year
    if (nextBirthday < today) {
        nextBirthday.setFullYear(today.getFullYear() + 1);
    }

    const diffTime = nextBirthday - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

const formatFileSize = (bytes) => {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let unitIndex = 0;

    while (bytes >= 1024 && unitIndex < units.length - 1) {
        bytes /= 1024;
        unitIndex++;
    }

    return `${bytes.toFixed(2)} ${units[unitIndex]}`;
};
export {
    formatPhoneNumber,
    formatDate,
    formatTime,
    formatDateTimeEst,
    formatTimeFull,
    formatCurrency,
    formatNumber,
    numberFormat,
    validateEmail,
    toDayDate,
    getAgeByDOB,
    getFormatedTemplateDetails,
    getFormatedTemplateDetailChiefComplaint,
    formatDateTime,
    getFormatedDate,
    formatDateTime2,
    formatDateTime3,
    formatSizeUnits,
    getSizeUnit,
    convertMinToHours,
    //getModulePermissionByRole,
    validDate,
    formateMdnNumber,
    formatDateByFormate,
    todayDate,
    validatePhoneNumber,
    handleNumberKeyPress,
    handleNumberKeyPressDecimal,
    handleNumberWithDecimal,
    handleNumberWithDecimalMaxLenght,
    numberDisplay,
    orderTrackStatus,
    shipmentStatus,
    communicationFormatedDate,
    loadNameInitials,
    allowedAttachments,
    allowedAttachmentsImages,
    validateDateOfBirth,
    getAgeByDOBInYears,
    wirelessStatus,
    isDigitsOnly,
    handleNumberChange,
    handleNegativeNumberWithDecimal,
    maskCreditCardNumber,
    maskCreditCardNumberPripaid,
    invoiceDocsAttachments,
    getLocalDateFromUTC,
    getDigitsToLocalString,
    generateRandomNumber,
    formatCreditCardNumber,
    handlePaste, formatNumberComma,
    getUserStatusText,
    maskCardNumber,
    calculateDaysDifference,
    IsVerizonSIM,
    CalculatePercentage,
    calculatePartFromPercentage,
    formatNumber2,
    maskCreditCardNumberFourDigits,
    maskAccountNumberFourDigits,
    getConfiguration,
    formatAmountComma,
    formatDateTimewithTime,
    formatDecimalNumber,
    formatDateBar,
    getConfigurationSync,
    formatFileSize,
    getRemainingDays
}